module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('Menu_Support', {

		configure: function () {

			this.registerOptions('', {
				list: {
					'tpl.row': 'support_tag'
				},
				widgets: {
					dl: {
						widget: 'Datalayer',
						method: 'Support.getAllTags',
						'hooks.onPrepareResponse': function (response) {
							var arr = []

							fox.each(response.collection, function (obj) {
								arr.push(obj);
							});

							fox.sortByField(arr, 'alias')
							
							response.collection = arr;

							this._apiResponse = response;
						}
					}
				}
			});

			this.callParent('configure', arguments)
		},

		running: function () {
			this.callParent('running', arguments);

			this.handleEvent(fox.Navigator, 'modified_2', this._handleNaviModifing, {listenHistory: true});
			this.handleEvent(fox.wom.selectFirst('~.Site_Page#support'), 'postLoaded', this._highlightByPostTag);
		},

		_handleNaviModifing: function (tag, navi, alias) {
			this._highlight(window.decodeURIComponent(tag));
		},

		_highlight: function (tag) {
			var list = this.wom1('#list');

			if (list._indom == true) {
				this.highlight(tag);

				return;
			};

			this.handleEvent(list, 'addedToDom', fox.bind(function () {
				this.highlight(tag);				
			}, this), {once: true});
		},

		_highlightByPostTag: function (postData) {
			var tagId = fox.getObjectKeys(postData.tags)[0];

			this.highlight(postData.tags[tagId].title);
		},

		highlight: function (tag) {
			fox.each(this.wom1('#list').dom('[data-tag]'), function (link) {
				var link = fox.dom.wrap(link);

				link.up(0)[(link.attr('data-tag') == tag ? 'addClass' : 'removeClass')]('active');
			}, this);
		}

	}, 'Grid');
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ../common/widget/menu/support.js
// module id = 468
// module chunks = 2